import {useEffect, useState} from "react";
import style from '../CSS/RoundVideoResult.module.css'
import camera from '../img/video-camera.png'


const ResultDetails = ({data}) => {
    const [items, setItems] = useState(null);

    useEffect(()=>{
        setItems(data);
    }, [])

    return (
        <>
            <div className={style.details}>
                <div className={style.details__header}>
                    <div className={style.info}>
                        <img src={camera} alt="profile"/>
                        <span>Video Feed Result</span>
                    </div>
                </div>
                <div>
                    <table className={style.table}>
                        <thead className={style.table__head}>
                        <tr>
                            <th>
                                <p>Total videos</p>
                            </th>
                            <th>
                                <p>Mark</p>
                            </th>
                        </tr>
                        </thead>

                        <tbody className={style.table__body}>
                        {
                            items && items.length > 0 && items.map((item, index)=>(
                                <tr key={index} style={{ background: index % 2 == 0 && '#333030'}}>
                                    <td>{index+1 }. <img src={item.video} alt=""/></td>
                                    <td>{item.mark}</td>
                                </tr>
                            ))
                        }
                        </tbody>
                    </table>
                </div>
            </div>
        </>
    );
};

export default ResultDetails;